import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function CtrModal() {
	return (
		<div className='performance_item_modal ctr_modal'>
			<h3>CTR</h3>
			<p>
				Low click-through rates indicate two very critical things.
			</p>
			<p>
				First, that your ad creative or offer is not resonating with your desired audience, and second, that your impressions may not be prioritized by Facebook.
			</p>
			<p>
				Make sure you have a way to track the effectiveness of all creative deployed in real-time, so you can make adjustments quickly and increase performance.
			</p>
		</div>
	)
}

const renderCtrBody = (value, global, us) => {
	if(value===null) {
		return (
			<p>We could not calculate your CTR since you have not run ads in the past 30 days.</p>
		)
	} else {
		const formatPercent = (num) => { return num.toLocaleString('en', {style: 'percent'}) }

		let percentStr = value + '%'
		let usDiff = formatPercent(Math.abs(us-value)/ us)
		let usLowerHigher = value < us ? 'lower' : 'higher'
		let globalDiff = formatPercent(Math.abs(global-value)/ global)
		let globalLowerHigher = value < global ? 'lower' : 'higher'

		return (
			<p>Your CTR is {percentStr}, which is {usDiff} {usLowerHigher} than the U.S. average and {globalDiff} {globalLowerHigher} than the global average.</p>
		)
	}
}

function CtrPerformanceItem(props) {
	const { score, maxScore, value, benchmark: { global, us } } = props.apiScore
	
	// "ctr":{"score":0,"maxScore":14,"value":null,"bechmark":{"us":1.25,"global":2}}
	return (
		<PerformanceItem
			title="CTR"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('ctr') }}>
			{renderCtrBody(value, global, us)}
		</PerformanceItem>
	)
}

CtrPerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}

export {CtrModal, CtrPerformanceItem}


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/performance_items/Ctr.js